<script lang="ts" setup>
import PrivacyPolicy from '~/components/pages/privacy-policy.vue';
import PrivacyPolicyPageContent from '~/utils/contents/pages/PrivacyPolicyPage';

definePageMeta({
  layout: 'empty',
  name: 'privacy-policy',
  auth: false,
});

useHead({
  title: PrivacyPolicyPageContent.seo.title,
});
</script>

<template>
  <div class="privacy-policy-page py-10">
    <PrivacyPolicy />
  </div>
</template>

<style lang="scss" scoped>
.privacy-policy-page {
  &__content {
    padding: $spacing-5xl;
  }
}
</style>
